import "core-js/modules/es.json.stringify.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "main-box"
  }, [_vm.typeIndex == 0 ? _c('div', {
    staticClass: "container-left-main"
  }, [_c('div', {
    staticClass: "container-left-main-position-color"
  }), _c('div', {
    staticClass: "container-left-main-name-wapper"
  }, [_c('div', {
    staticClass: "container-left-main-name"
  }, [_vm._v("待办表单")]), _c('a', {
    class: _vm.loadings ? 'container-left-main-icon1' : 'container-left-main-icon',
    on: {
      "click": function click($event) {
        return _vm.handleLoading();
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": require("../assets/img/jiazai.png"),
      "alt": ""
    }
  })])]), _c('div', {
    staticClass: "container-left-main-title-wapper"
  }, [_vm.showLoading ? _c('div', {
    staticClass: "container-left-main-position"
  }, [_c('a-spin')], 1) : _vm._e(), _c('div', {
    staticClass: "container-left-main-title"
  }, [_c('div', {
    staticClass: "container-left-main-title-left"
  }, [_c('a', {
    class: _vm.mainLeftIndex == 0 ? 'container-left-main-title-left-txt1' : 'container-left-main-title-left-txt2',
    on: {
      "click": function click($event) {
        return _vm.changeMainIndex(0);
      }
    }
  }, [_c('div', [_vm._v("待办")])]), _c('a', {
    class: _vm.mainLeftIndex == 1 ? 'container-left-main-title-left-txt1' : 'container-left-main-title-left-txt2',
    on: {
      "click": function click($event) {
        return _vm.changeMainIndex(1);
      }
    }
  }, [_c('div', [_vm._v("已办")])])]), _c('a', {
    staticClass: "container-left-main-title-right",
    on: {
      "click": _vm.toWaitdo
    }
  }, [_vm._v("查看更多")])]), _vm.mainLeftIndex == 0 && _vm.mainList ? _c('div', {
    staticClass: "container-left-main-scorllMain"
  }, [JSON.stringify(_vm.daibanList) == '[]' ? _c('a-empty', {
    attrs: {
      "image": _vm.simpleImage
    }
  }) : _vm._e(), _vm._l(_vm.daibanList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "container-left-main-scorllMain-menu",
      on: {
        "click": function click($event) {
          return _vm.applyAudit({}, item);
        }
      }
    }, [_c('div', {
      staticClass: "container-left-main-scorllMain-menu-message",
      on: {
        "click": function click($event) {
          return _vm.toView(item);
        }
      }
    }, [_c('a', {
      staticClass: "container-left-main-scorllMain-menu-message-top"
    }, [_c('div', {
      staticClass: "container-left-main-scorllMain-menu-message-round-left"
    }, [_c('div', {
      staticClass: "container-left-main-scorllMain-menu-message-round"
    }), _c('div', {
      staticClass: "container-left-main-scorllMain-txt"
    }, [_vm._v(" 请审批[" + _vm._s(item.startUserName) + "]提交的表单：" + _vm._s(item.formName) + " ")])]), _c('div', {
      staticClass: "container-left-main-scorllMain-time"
    }, [_vm._v(" " + _vm._s(item.createTime) + " ")])])])]);
  })], 2) : _c('div', {
    staticClass: "container-left-main-scorllMain"
  }, [JSON.stringify(_vm.yibanList) == '[]' ? _c('a-empty', {
    attrs: {
      "image": _vm.simpleImage
    }
  }) : _vm._e(), _vm._l(_vm.yibanList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "container-left-main-scorllMain-menu",
      on: {
        "click": function click($event) {
          return _vm.onViewAfterMeApply({}, item);
        }
      }
    }, [_c('div', {
      staticClass: "container-left-main-scorllMain-menu-message"
    }, [_c('a', {
      staticClass: "container-left-main-scorllMain-menu-message-top"
    }, [_c('div', {
      staticClass: "container-left-main-scorllMain-menu-message-round-left"
    }, [_c('div', {
      staticClass: "container-left-main-scorllMain-menu-message-round"
    }), _c('div', {
      staticClass: "container-left-main-scorllMain-txt"
    }, [_vm._v(" 请审批[" + _vm._s(item.startUserName) + "]提交的表单：" + _vm._s(item.formName) + " ")])]), _c('div', {
      staticClass: "container-left-main-scorllMain-time"
    }, [_vm._v(" " + _vm._s(item.createTime) + " ")])])])]);
  })], 2)])]) : _c('div', {
    staticClass: "container-left-main",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "container-left-main-position-color"
  }), _c('div', {
    staticClass: "container-left-main-name-wapper"
  }, [_c('div', {
    staticClass: "container-left-main-name"
  }, [_vm._v("待阅表单")]), _c('a', {
    class: _vm.loadings1 ? 'container-left-main-icon1' : 'container-left-main-icon',
    on: {
      "click": function click($event) {
        return _vm.handleLoading1();
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": require("../assets/img/jiazai.png"),
      "alt": ""
    }
  })])]), _c('div', {
    staticClass: "container-left-main-title-wapper"
  }, [_vm.showLoading1 ? _c('div', {
    staticClass: "container-left-main-position"
  }, [_c('a-spin')], 1) : _vm._e(), _c('div', {
    staticClass: "container-left-main-title"
  }, [_c('div', {
    staticClass: "container-left-main-title-left"
  }, [_c('a', {
    class: _vm.mainRightIndex == 0 ? 'container-left-main-title-left-txt1' : 'container-left-main-title-left-txt2',
    on: {
      "click": function click($event) {
        return _vm.changeMainRightIndex(0);
      }
    }
  }, [_c('div', [_vm._v("待阅")])]), _c('a', {
    class: _vm.mainRightIndex == 1 ? 'container-left-main-title-left-txt1' : 'container-left-main-title-left-txt2',
    on: {
      "click": function click($event) {
        return _vm.changeMainRightIndex(1);
      }
    }
  }, [_c('div', [_vm._v("已阅")])])]), _c('a', {
    staticClass: "container-left-main-title-right",
    on: {
      "click": _vm.toWaitdo
    }
  }, [_vm._v("查看更多")])]), _vm.mainRightIndex == 0 ? _c('div', {
    staticClass: "container-left-main-scorllMain"
  }, [JSON.stringify(_vm.daiyueList) == '[]' ? _c('a-empty', {
    attrs: {
      "image": _vm.simpleImage
    }
  }) : _vm._e(), _vm._l(_vm.daiyueList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "container-left-main-scorllMain-menu"
    }, [_c('div', {
      staticClass: "container-left-main-scorllMain-menu-message",
      on: {
        "click": function click($event) {
          return _vm.toViewCopy(item);
        }
      }
    }, [_c('a', {
      staticClass: "container-left-main-scorllMain-menu-message-top"
    }, [_c('div', {
      staticClass: "container-left-main-scorllMain-menu-message-round-left"
    }, [_c('div', {
      staticClass: "container-left-main-scorllMain-menu-message-round"
    }), _c('div', {
      staticClass: "container-left-main-scorllMain-txt"
    }, [_vm._v(" 请审批[" + _vm._s(item.userName) + "]提交的表单：" + _vm._s(item.formName) + " ")])]), _c('div', {
      staticClass: "container-left-main-scorllMain-time"
    }, [_vm._v(" " + _vm._s(item.createTime) + " ")])])])]);
  })], 2) : _c('div', {
    staticClass: "container-left-main-scorllMain"
  }, [JSON.stringify(_vm.yiyueList) == '[]' ? _c('a-empty', {
    attrs: {
      "image": _vm.simpleImage
    }
  }) : _vm._e(), _vm._l(_vm.yiyueList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "container-left-main-scorllMain-menu"
    }, [_c('div', {
      staticClass: "container-left-main-scorllMain-menu-message",
      on: {
        "click": function click($event) {
          return _vm.toViewCopy(item);
        }
      }
    }, [_c('a', {
      staticClass: "container-left-main-scorllMain-menu-message-top"
    }, [_c('div', {
      staticClass: "container-left-main-scorllMain-menu-message-round-left"
    }, [_c('div', {
      staticClass: "container-left-main-scorllMain-menu-message-round"
    }), _c('div', {
      staticClass: "container-left-main-scorllMain-txt"
    }, [_vm._v(" 请审批[" + _vm._s(item.userName) + "]提交的表单：" + _vm._s(item.formName) + " ")])]), _c('div', {
      staticClass: "container-left-main-scorllMain-time"
    }, [_vm._v(" " + _vm._s(item.createTime) + " ")])])])]);
  })], 2)])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };